<template>
  <div class="fazhan">

    <div class="header animate__animated wow animate__fadeInUp">
      <div class="IosPic">
        <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/8C15CD3C09B4426DA095721C39016285-6-2.png" alt="">
      </div>
      <div class="left">
        <p>国医通致力于为肾脏病患者提供创新服务和优质产品，围绕肾病患者、医院科室、医生护士、工商企业提供一站式的整体解决方案。</p>
        <p>业务主要分为“创新服务”、“工业生产”、“商业渠道”、“医学培训”及“信息平台”五大板块。</p>
        <p>我们始终践行以科学技术和创新服务推动行业发展、赋能基层医疗、造福广大患者。</p>
      </div>
      <div class="right">
        <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/8C15CD3C09B4426DA095721C39016285-6-2.png" alt="">
      </div>
    </div>
    <div class="title">
      <titleCard title="发展历程"></titleCard>
    </div>
    <div class="main animate__animated wow animate__fadeInUp">
      <div class="main-box">
        <div class="box box1">
          <div class="dian"></div>
          <div class="text text1">
            <div class="content">
              <p>与旧宫医院签约了社区透析服务协议；</p>
              <p>与哈汽医院签订了服务合作协议。</p>
              </div>
            <div class="titles">
              2016年 国医通成立
            </div>
          </div>
        </div>
        <div class="box box2">
          <div class="dian"></div>
          <div class="text text2">
            <div class="titles">
              2017年
            </div>
            <p>德诚资本注资2200万元，获得国家“高新技术企业”证书；</p>
            <p>与吉林正大国际医院签订合作服务协议。</p>
          </div>
        </div>
        <div class="box box3">
          <div class="dian"></div>
          <div class="text text3">
            <p>与北京大学人民医院共同成立“中国研究型医院学会血液净化专业委员会”，成员涵盖102名肾内科知名专家；</p>
            <p>德诚资本注资6000万元，投后估值2.4亿元。</p>
            <div class="titles">
              2018年
            </div>
          </div>
        </div>
        <div class="box box4">
          <div class="dian"></div>
          <div class="text text4">
            <div class="titles">
              2019年
            </div>
            <p>获得国家卫健委继教中心“全国血液透析专项能力培训”项目授权；</p>
            <p>与北大国际医院签约打造卫健委第一家透析进修基地。</p>
          </div>
        </div>
        <div class="box box5">
          <div class="dian"></div>
          <div class="text text5">
            <p>获得国家卫健委“县域医疗卫生服务能力提升工程”血液透析合作试点单位；</p>
            <p>完成首个自主工业产品的布局。</p> 
            <div class="titles">
              2020年
            </div>
          </div>
        </div>
        <div class="box box6">
          <div class="dian"></div>
          <div class="text text6">
            <div class="titles">
              2021年
            </div>
            商业网络，培训网络，工业网络进一步完善，完成了新一轮的融资。
          </div>
        </div>
        <div class="box box7">
          <div class="dian"></div>
          <div class="text text7">
            截止7月 业务已覆盖500+家医疗机构，其中基层医疗机构150+家。
            <div class="titles">
              2022年
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer animate__animated wow animate__fadeInUp">
      <div class="footer-title">
        <titleCard title="联系我们"></titleCard>
      </div>
      <div class="map">
        <template>
          <iframe src="http://testwww.gytcare.com/map.html" width="100%" height="100%" frameborder="0"></iframe>
        </template>
      </div>
      <div class="address">
        <div class="txtbox">
          <h3>联系地址：</h3>
          <p>北京市朝阳区东四环中路41号嘉泰大厦B座704室</p>
        </div>
        <div class="txtbox right">
          <h3>联系地址：</h3>
          <p>北京市朝阳区东四环中路41号嘉泰大厦B座713室</p>
        </div>
        <div class="icon">
          <img src="../../assets/image/About/icon1.webp" alt="">
        </div>
      </div>
      <div class="phone">
        <div class="txtbox txtbox1">
          <h3>联系电话：</h3>
          <p>010-67207401</p>
        </div>
        <div class="txtbox">
          <h3>联系邮箱：</h3>
          <p>zhangshixia@gytcare.com</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titleCard from '../../components/title-card.vue'
export default {
  data() {
    return {
      rootUrl:window.location.href.split("/")[2]
    }
  },
  components: {
    titleCard
  },
  created() {

  },
  mounted() {

  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.fazhan {
  position: relative;
  .header {
    height: 7.6842rem;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 540px) {
      height: 100%;
      display: block;
    }
    .IosPic {
      display: none;
      width: 100%;
      height: 260px;
      @media screen and (max-width: 540px) {
        display: block;
      }
      margin: 25px 0;
      padding: 0 55px;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .left {
      width: 5.5789rem;
      @media screen and (max-width: 540px) {
        width: 100%;
        padding: 0 25px;
        box-sizing: border-box;
      }
      p {
        padding-bottom: 0.3789rem;
        color: #666666;
        font-size: 0.2005rem;
        @media screen and (max-width: 540px) {
          font-size: 15px;
          padding-bottom: 20px;
        }
      }
    }
    .right {
      @media screen and (max-width: 540px) {
        display: none;
      }
      margin-left: 1.4105rem;
      width: 6.5421rem;
      height: 5.6632rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .main::-webkit-scrollbar {
    display: none;
  }
  .title {
    position: absolute;
    left: 50%;
    top: 30%;
    z-index: 999;
    transform: translateX(-50%);
    @media screen and (max-width: 540px) {
      top: 30%;
    }
  }
  .main {
    height: 10.9474rem;
    width: 100%;
    background-image: url('https://yyt-ows.oss-cn-beijing.aliyuncs.com/3858FBEFA048454EBA0F18A3241CAB82-6-2.png');
    background-size: 100% 100%;
    box-sizing: border-box;
    position: relative;
    .box {
      position: absolute;
      @media screen and (max-width: 540px) {
        display: none;
      }
      .text {
        position: absolute;
        height: auto;
        top: 0;
        left: 0;
        font-size: 0.1895rem;
        padding-left: 0.3rem;
        color: #666666;
        .titles {
          font-size: 0.2632rem;
          color: #0ca6eb;
          margin: 0.2105rem 0;
          display: flex;
          align-items: center;
          font-weight: 600;
          .icon {
            width: 0.2105rem;
            height: 0.2105rem;
            margin-right: 0.1474rem;
            background: url('../../assets/image/About/bottom.png') no-repeat;
            background-size: 100% 100%;
          }
          .icon2 {
            background: url('../../assets/image/About/top.png') no-repeat;
            background-size: 100% 100%;
          }
        }
      }
      .text1 {
        width: 3.9474rem;
        left: -0.1063rem;
        top: -1.7542rem;
        p{
          padding-bottom: 10px;
        }
      }
      .text2 {
        width: 5.1474rem;
        left: -0.1063rem;
        top: 0.08rem;
        p{
          padding-top: 10px;
        }
      }
      .text3 {
        width: 5rem;
        top: -2.27rem;
        left: -0.1rem;
        p{
          padding-bottom: 15px;
        }
      }
      .text4 {
        width: 4.8474rem;
        left: -0.1063rem;
        top: 0.05rem;
        p{
          padding-top: 10px;
        }
      }
      .text5 {
        width: 4.5rem;
        top:-2.1547rem;
        left: -0.05rem;
        p{
          padding-bottom: 15px;
        }
      }
      .text6{
        width: 3.8474rem;
        left: -0.1063rem;
        top: 0.08rem;
      }
      .text7 {
        width: 3.3rem;
        top: -2.1421rem;
        left: -0.1053rem;
      }
      .dian {
        width: 0.2632rem;
        height: 0.2632rem;
        // background: url('../../assets/image/About/xian.png') no-repeat;
        background-size: 100% 100%;
        margin-left: -0.1263rem;
        margin-bottom: -0.0526rem;
      }
    }
    .box1 {
      left: 0.7089rem;
      bottom: 1.6032rem;
    }
    .box2 {
      left: 4.5911rem;
      bottom: 2.6211rem;
    }
    .box3 {
      left: 6.05979rem;
      bottom: 3.4842rem;
    }
    .box4 {
      left: 9.09953rem;
      bottom: 4.2632rem;
    }
    .box5 {
      right: 8.4084rem;
      bottom: 4.55rem;
    }
    .box6 {
      right: 5.9532rem;
      bottom: 5.0874rem;
    }
    .box7 {
      right: 3.7474rem;
      bottom: 5.7368rem;
    }
    @media screen and (max-width: 540px) {
      background-image: none;
      height: 800px;
      overflow: scroll;
      overflow-y: hidden;
      background: none;
      padding: 0;
    }
    .main-box {
      width: 100%;
      height: 100%;
      background-size: 100% 100%;
      @media screen and (max-width: 540px) {
        background-size: 100% 100%;
        height: 100%;
        width:1400px;
        background: url('https://yyt-ows.oss-cn-beijing.aliyuncs.com/51FC368D3BAE4155ACE4298D9EADDF7E-6-2.png');
        background-size: 100% 100%;
        background-position: 0 100%;
      }
    }
  }
  .footer {
    padding: 0.8632rem 1.6842rem 1.6842rem 1.6842rem;
    @media screen and (max-width: 540px) {
      padding: 0 15px;
    }
    .footer-title {
      margin-bottom: 0.5684rem;
      @media screen and (max-width: 540px) {
        padding: 58px 0 20px 0;
      }
    }
    .map {
      height: 3.5789rem;
      width: 100%;
      // background: url('../../assets/image/About/map.webp') no-repeat;
      // background-size: 100% 100%;
      @media screen and (max-width: 540px) {
        height: 170px;
        background-size: cover;
        background-position-x: 50%;
      }
    }
    .address {
      height: 1.6316rem;
      padding: 0 0.3158rem;
      border-bottom: 1px solid #e1e1e1;
      display: flex;
      align-items: center;
      @media screen and (max-width: 540px) {
        height: 100%;
        padding: 19px 0;
      }
      .txtbox {
        // width: 5.4737rem;
        padding-right: 1.6842rem;
        @media screen and (max-width: 540px) {
          width: 50%;
          padding: 0;
        }
        h3 {
          color: #6a7073;
          font-size: 0.2526rem;
          margin: 0;
          @media screen and (max-width: 540px) {
            font-size: 14px;
          }
        }
        p {
          padding-top: 0.2421rem;
          font-size: 0.2526rem;
          color: #888a8b;
          @media screen and (max-width: 540px) {
            padding-right: 10px;
            font-size: 12px;
          }
        }
      }
      .right {
        padding-right: 2.8421rem;
        @media screen and (max-width: 540px) {
          padding: 0;
        }
      }
      .icon {
        width: 0.3684rem;
        height: 0.4842rem;
        margin-top: 0.4211rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .phone {
      height: 1.6316rem;
      display: flex;
      align-items: center;
      padding: 0 0.3158rem;
      @media screen and (max-width: 540px) {
        height: 100%;
        padding: 19px 0;
      }
      .txtbox1{
        padding-right:5.3837rem;
      }
      .txtbox {
        // width: 5.4737rem;
        @media screen and (max-width: 540px) {
          width: 50%;
          padding: 0;
        }
        h3 {
          color: #6a7073;
          font-size: 0.2526rem;
          margin: 0;
          @media screen and (max-width: 540px) {
            font-size: 14px;
          }
        }
        p {
          padding-top: 0.2421rem;
          font-size: 0.2526rem;
          color: #888a8b;
          @media screen and (max-width: 540px) {
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
